import React from 'react';
import { motion } from 'framer-motion';
export function WhatIsSection() {
  return <section className="w-full bg-cream-50 py-20 md:py-28 px-4" data-id="element-129">
      <div className="max-w-3xl mx-auto" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="text-center" data-id="element-131">
          <h2 className="font-heading text-3xl md:text-4xl text-brown-700 mb-8" data-id="element-132">
            ¿Qué es "Manifiesta en Armonía"?
          </h2>

          <p className="text-lg text-brown-600 leading-relaxed mb-8" data-id="element-133">
            Es un PDF profundo y práctico que te guía en{' '}
            <span className="font-semibold text-gold-600" data-id="element-134">12 módulos</span> para
            integrar el proceso completo de manifestación: desde lo interno
            (creencias, emociones, cuerpo, niña interior) hasta lo externo
            (hábitos, límites, dinero, acción y entrega).
          </p>

          <motion.blockquote initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative bg-gradient-to-r from-gold-100/50 to-cream-200 border-l-4 border-gold-500 px-8 py-6 rounded-r-2xl my-10" data-id="element-135">
            <p className="font-heading text-xl md:text-2xl italic text-brown-700" data-id="element-136">
              "Acá no venís a pensar positivo. Venís a ordenarte por dentro para
              poder recibir y sostener por fuera."
            </p>
          </motion.blockquote>

          <p className="text-brown-500" data-id="element-137">
            Un camino ordenado para alinear tu interior con tu realidad: limpiar
            creencias, regular tu energía, fortalecer límites, sanar
            merecimiento y materializar con coherencia.
          </p>
        </motion.div>
      </div>
    </section>;
}